export default __webpack_public_path__ + "static/media/client9.b1a920ef.png";